import { type PropsWithChildren, StrictMode } from 'react';
import { type History, Router, renderRoutes } from '@lingoda/router';
import { withProfiler } from '@lingoda/monitor';
import { Suspense } from '@lingoda/ui';
import { getDashLang } from '@lingoda/env';
import routes from '../routes';
import { ContextProviders } from './ContextProviders';
import { PageErrorBoundary } from './PageErrorBoundary';
import { QuizGraphQLProvider } from './QuizGraphQLProvider';
import { MonolithGraphQLProvider } from './MonolithGraphQLProvider';

interface Props {
    history: History;
}

const Root = (props: PropsWithChildren<Props>) => {
    return (
        <StrictMode>
            <MonolithGraphQLProvider>
                <QuizGraphQLProvider>
                    <PageErrorBoundary>
                        <Router history={props.history}>
                            <ContextProviders locale={getDashLang()}>
                                <Suspense variant="linear">{renderRoutes(routes)}</Suspense>
                            </ContextProviders>
                        </Router>
                    </PageErrorBoundary>
                </QuizGraphQLProvider>
            </MonolithGraphQLProvider>
        </StrictMode>
    );
};

export default withProfiler(Root, { name: 'StudentRoot' });
